angular.module('v3sWbtPlayerApp').factory('v3sToolsService', ["$rootScope", "$aside", "v3sAsideService", "v3sI18nService", "v3sSearchService", function ($rootScope, $aside, v3sAsideService, v3sI18nService, v3sSearchService) {

    var TOGGLE_TREE = "v3sEventToggleTree";
    var HIDE_TREE = "v3sEventHideTree";
    var PAGE_CHANGED = "v3sEventPageChanged";

    function toggleTree(page) {
        $rootScope.$emit(TOGGLE_TREE, page);
    }

    function onToggleTree($scope, handler) {
        var listener = $rootScope.$on(TOGGLE_TREE, function (event, page) {
            handler(page);
        });
        $scope.$on('$destroy', listener);
    };

    function onHideTree($scope, handler) {
        var listener = $rootScope.$on(HIDE_TREE, function (event) {
            handler();
        });
        $scope.$on('$destroy', listener);
    };


    var search = $aside({ title: v3sI18nService.getText("dialogs.search.title"), templateUrl: 'app/js/tools/aside.tpl.html', contentTemplate: 'app/js/tools/search/search.tpl.html', show: false });
    var lexikon = $aside({ title: "", templateUrl: 'app/js/tools/aside.tpl.html', contentTemplate: 'app/js/tools/search/lexikon.tpl.html', show: false });

    v3sSearchService.setLexikonElement(lexikon);
    function toggleSearch() {
        search.$promise.then(function () {
            if (lexikon.$isShown) {
                lexikon.hide();
            } else if (search.$isShown) {
                search.hide();
            } else {
                search.show();

                v3sAsideService.makeDraggable(search);

                search.$scope.$on('aside.hide.before', function (event) {
                    if (lexikon.$isShown) {
                        lexikon.hide();
                        event.preventDefault();
                    }
                });
            }

            v3sSearchService.init();
        });
    }

    function hideSearch() {
        if (search.$isShown) {
            search.hide();
        }
    }
    function hideTree() {
        $rootScope.$emit(HIDE_TREE);
    }

    function pageChanged(page) {
        $rootScope.$emit(PAGE_CHANGED, page);
    }

    function onPageChanged($scope, handler) {
        var listener = $rootScope.$on(PAGE_CHANGED, function (event, page) {
            handler(page);
        });
        $scope.$on('$destroy', listener);
    };

    return {
        toggleTree: toggleTree,
        hideTree : hideTree,
        toggleSearch : toggleSearch,
        hideSearch : hideSearch,
        onToggleTree: onToggleTree,
        onHideTree: onHideTree,
        pageChanged: pageChanged,
        onPageChanged: onPageChanged
    }
}]);